import React, { useEffect } from "react";
import Modal from "../Modal";
import Button from "../Button";

// - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
// #124 react-joyride Time Machine tutorial — Reset-confirm modal.
//
// Opened from the "Reset Time Machine Tutorial" item in the avatar
// dropdown. Three options:
//   - Take it now           → mutate completed=false AND fire the tour
//                             immediately
//   - Reset for next login  → mutate completed=false, close modal
//                             (tour fires on next browser session)
//   - Cancel                → close, no DB write
//
// Esc dismisses as Cancel — same conservative default as IntroModal.

const ResetTutorialConfirmModal = ({
  open,
  onTakeNow,
  onResetForNextLogin,
  onCancel,
}) => {
  useEffect(() => {
    if (!open) return;
    const handleKey = (event) => {
      if (event.key === "Escape") {
        event.stopPropagation();
        onCancel();
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <Modal onClose={onCancel}>
      <Modal.Header>Reset Time Machine Tutorial</Modal.Header>
      <Modal.Content>
        <div className="w-[480px] flex flex-col gap-3 text-sm">
          <p>
            Resetting the tutorial marks it as not-yet-completed for your
            account. You can take it now, or it will fire again the next
            time the app loads.
          </p>
          <p className="opacity-75 italic">
            This only affects your own account — other users are unaffected.
          </p>
        </div>
      </Modal.Content>
      <Modal.Footer>
        <div className="flex items-center justify-end gap-2">
          <Button
            color="light"
            className="uppercase"
            onClick={onCancel}
          >
            Cancel
          </Button>
          <Button
            color="light"
            className="uppercase"
            onClick={onResetForNextLogin}
          >
            Reset for Next Login
          </Button>
          <Button
            color="primary"
            className="uppercase"
            onClick={onTakeNow}
          >
            Take It Now
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default ResetTutorialConfirmModal;
